module.exports = __webpack_public_path__ + "img/logos.6bb92ab0.png";